import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Service from 'components/atoms/Service';

// Constants
import { SERVICES_TYPE } from 'constants/services';

// Utils
import { splitCamelCase } from 'utils/string';

import './SCIEditServicesList.scss';

const ns = 'edit-services-list';

class SCIEditServicesList extends React.Component {
  constructor(props) {
    super(props);
    this.addAdditionalService = this.addAdditionalService.bind(this);
    this.removeAdditionalService = this.removeAdditionalService.bind(this);
  }

  serviceAlreadyExists = id => {
    const { additionalServices } = this.props;
    const stringToSearch = `id: ${id},`;
    const exists = additionalServices.search(stringToSearch);
    return exists >= 0;
  };

  removeAdditionalService = id => {
    const { updateAdditionalServices, additionalServices } = this.props;
    const servicePosition = additionalServices.indexOf(`id: ${id},`);
    const serviceEndPosition =
      additionalServices.indexOf(';', servicePosition) + 1;
    const stringToRemove = additionalServices.substr(
      servicePosition,
      serviceEndPosition - servicePosition
    );
    const updatedNotes = additionalServices.replace(stringToRemove, '');
    if (updatedNotes.trim().length < 1) {
      updateAdditionalServices('');
    } else {
      updateAdditionalServices(updatedNotes);
    }
  };

  addAdditionalService = service => {
    const {
      gtmUserEvent,
      updateAdditionalServices,
      additionalServices,
      group
    } = this.props;
    const { id, name } = service;
    const serviceAlreadyExists = this.serviceAlreadyExists(id);
    const serviceData = `id: ${id}, name: ${name};`;
    const addedService = additionalServices
      ? `${additionalServices} ${serviceData}`
      : serviceData;
    if (!serviceAlreadyExists) {
      updateAdditionalServices(addedService);
      gtmUserEvent(
        'Service',
        'Selected',
        'Service Added To Appointment',
        `GTM_CURRENT_PAGE > ${splitCamelCase(group)} Services Section`,
        name
      );
    } else {
      this.removeAdditionalService(id);
    }
  };

  render() {
    const { serviceList, className } = this.props;
    const { id } = serviceList;
    const classProps = classNames(ns, className);
    return (
      <div className={classProps}>
        {serviceList.map(service => {
          const isSelected = this.serviceAlreadyExists(service.id);
          return (
            <Service
              key={id}
              service={service}
              onSelect={service => this.addAdditionalService(service)}
              isSelected={isSelected}
              type={SERVICES_TYPE.ALACARTE}
            />
          );
        })}
      </div>
    );
  }
}

SCIEditServicesList.propTypes = {
  className: PropTypes.string,
  group: PropTypes.string,
  gtmUserEvent: PropTypes.func.isRequired,
  serviceList: PropTypes.array.isRequired,
  updateTellusmoreService: PropTypes.bool.isRequired,
  updateAdditionalServices: PropTypes.func.isRequired,
  additionalServices: PropTypes.string
};

export default SCIEditServicesList;



// WEBPACK FOOTER //
// ./src/components/molecules/SCIEditServicesList/SCIEditServicesList.js